import { containerless, child, bindable, bindingMode, customElement } from 'aurelia-framework';
import { inject, Parent } from 'aurelia-dependency-injection';
import { BootstrapNavs } from './fs-navs';

@inject(Element, Parent.of(BootstrapNavs))
@containerless
@customElement('fs-nav-item')
export class BootstrapNavItem {

    @bindable({ defaultBindingMode: bindingMode.oneWay }) public class: string;
    @bindable({ defaultBindingMode: bindingMode.oneWay }) public style: string;

    @bindable({ defaultBindingMode: bindingMode.oneWay }) public href: string;
    @bindable({ defaultBindingMode: bindingMode.oneWay }) public title: string;

    @bindable({ defaultBindingMode: bindingMode.oneWay }) public id: string;

    @bindable({ defaultBindingMode: bindingMode.oneTime }) public active: boolean | string = false;
    @bindable({ defaultBindingMode: bindingMode.oneWay }) public disabled: boolean | string = false;

    private isFade: boolean = false;

    public element: Element;
    public parent: any;

    constructor(element: Element, parent) {
        this.element = <HTMLElement>element;
        this.parent = parent;
    }

    bind(bindingContext: any, overrideContext: any) {

        this.active = this.active === 'true' || this.active === true;
        this.disabled = this.disabled === 'true' || this.disabled === true;

    }
}